// API endpoint paths (base URL comes from environment variables)
export const PREPARE_PATH = '/prepare-meta-tx';
export const SUBMIT_PATH = '/submit-meta-tx';
export const TOKENS_PATH = '/tokens';
export const getSwapsPath = (orderId: string) => `/swaps/${orderId}`;
